import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

// Login Redux States
import { UPDATE_WORK_STATUS_WS } from './actionTypes';
import { updateWorkStatusWSSuccess, updateWorkStatusWSError } from './actions';

// Include call API
import { getWorkstationsAPI } from '../../../api/workstations';

const workstationAPI = getWorkstationsAPI();

function* updateWorkStatusWS({ payload: { ws, isClosed, token, history } }) {
  try {
    const response = yield call(workstationAPI.updateWorkStatusWorkstation, ws, isClosed, token);
    yield put(updateWorkStatusWSSuccess(response.message));
    history.go();
  } catch (error) {
    yield put(updateWorkStatusWSError(error));
  }
}

export function* watchUpdateWorkStatusWS() {
  yield takeEvery(UPDATE_WORK_STATUS_WS, updateWorkStatusWS);
}

function* UpdateWorkStatusWSSaga() {
  yield all([fork(watchUpdateWorkStatusWS)]);
}

export default UpdateWorkStatusWSSaga;
